/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";

import { Button, Card, Divider, Form, Input, message } from "antd";
import { useHistory, useLocation } from "react-router-dom";

import { useAppTheme } from "../../context/ThemeProvider";
import { TM_PRIMARY, TM_SECONDARY } from "../../Utils/colors";
import { showAppError } from "../../Utils/error";
import { userLogin } from "../api/index";
import logo from "./logo-color.png";

const Login = ({ setIsRestricted, setAllowedFunctions }) => {
  const history = useHistory();
  const location = useLocation();

  const { updateColors } = useAppTheme();

  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleOnFinish = async (value) => {
    if (!value.email || !value.password) {
      message.error("Please enter email and password correctly");
      return;
    }

    setIsLoggingIn(true);

    try {
      const response = await userLogin(value);
      if (response.code === 0) {
        localStorage.setItem("token", response?.result?.token);
        setIsRestricted(response?.result?.isRestricted);
        setAllowedFunctions(response?.result?.allowedFunctions);

        // eslint-disable-next-line no-undef
        // changeAppTheme("primary-color", PRIMARY);

        updateColors({
          PRIMARY: TM_PRIMARY,
          SECONDARY: TM_SECONDARY,
        });

        // eslint-disable-next-line no-undef
        // changeAppTheme("secondary-color", SECONDARY);

        message.success("Logged in successfully");

        setTimeout(() => {
          history.push("/dashboard");
        }, 200);
      } else {
        showAppError(response);
      }
    } catch (error) {
      showAppError(error);
    } finally {
      setIsLoggingIn(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      history.push("/login");
    } else {
      history.push("/dashboard");
    }
  }, [location.pathname]);

  return (
    <div className="siteLogin">
      <Card
        bordered={false}
        bodyStyle={{
          width: 420,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={logo} alt="TagMango Logo" width={145} />
        <Divider className="customDivider noBorder" />
        <Form
          layout="vertical"
          style={{ width: "100%" }}
          onFinish={handleOnFinish}
        >
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input placeholder="Email" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password placeholder="Password" size="large" />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={isLoggingIn}
            disabled={isLoggingIn}
          >
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
